{
  "maximum": "최대",
  "minimum": "최소"
}
